//***** Email Inbound Actions *****/
export const EMAIL_INBOUND_GET_LIST = "EMAIL_INBOUND_GET_LIST";
export const EMAIL_INBOUND_GET_LIST_SUCCESS = "EMAIL_INBOUND_GET_LIST_SUCCESS";
export const EMAIL_INBOUND_GET_LIST_ERROR = "EMAIL_INBOUND_GET_LIST_ERROR";

//***** Single Email Inbound Actions *****/
export const EMAIL_INBOUND_GET_SINGLE = "EMAIL_INBOUND_GET_SINGLE";
export const EMAIL_INBOUND_GET_SINGLE_SUCCESS =
  "EMAIL_INBOUND_GET_SINGLE_SUCCESS";
export const EMAIL_INBOUND_GET_SINGLE_ERROR = "EMAIL_INBOUND_GET_SINGLE_ERROR";

//***** Email Archive Inbound Actions *****/

export const EMAIL_INBOUND_ARCHIVE = "EMAIL_INBOUND_ARCHIVE";
export const EMAIL_INBOUND_ARCHIVE_SUCCESS = "EMAIL_INBOUND_ARCHIVE_SUCCESS";
export const EMAIL_INBOUND_ARCHIVE_ERROR = "EMAIL_INBOUND_ARCHIVE_ERROR";

//***** Email Mass Marked Read Inbound Actions *****/
export const EMAIL_INBOUND_MASS_MARKED_READ = "EMAIL_INBOUND_MASS_MARKED_READ";
export const EMAIL_INBOUND_MASS_MARKED_READ_SUCCESS =
  "EMAIL_INBOUND_MASS_MARKED_READ_SUCCESS";
export const EMAIL_INBOUND_MASS_MARKED_READ_ERROR =
  "EMAIL_INBOUND_MASS_MARKED_READ_ERROR";

//***** Email Outbound Actions *****/

export const EMAIL_OUTBOUND_SEND_EMAIL = "EMAIL_OUTBOUND_SEND_EMAIL";
export const EMAIL_OUTBOUND_SEND_EMAIL_SUCCESS =
  "EMAIL_OUTBOUND_SEND_EMAIL_SUCCESS";
export const EMAIL_OUTBOUND_SEND_EMAIL_ERROR =
  "EMAIL_OUTBOUND_SEND_EMAIL_ERROR";

// Email Assign update staff actions

export const EMAIL_INBOUND_UPDATE_STAFF = "EMAIL_INBOUND_UPDATE_STAFF";
export const EMAIL_INBOUND_UPDATE_STAFF_SUCCESS =
  "EMAIL_INBOUND_UPDATE_STAFF_SUCCESS";
export const EMAIL_INBOUND_UPDATE_STAFF_ERROR =
  "EMAIL_INBOUND_UPDATE_STAFF_ERROR";

// Email Account List Outbound From Actions

export const EMAIL_OUTBOUND_ACCOUNT_LIST = "EMAIL_OUTBOUND_ACCOUNT_LIST";
export const EMAIL_OUTBOUND_ACCOUNT_LIST_SUCCESS =
  "EMAIL_OUTBOUND_ACCOUNT_LIST_SUCCESS";
export const EMAIL_OUTBOUND_ACCOUNT_LIST_ERROR =
  "EMAIL_OUTBOUND_ACCOUNT_LIST_ERROR";

// Archived Email List ActionType

export const EMAIL_INBOUND_ARCHIVE_LIST = "EMAIL_INBOUND_ARCHIVE_LIST";
export const EMAIL_INBOUND_ARCHIVE_LIST_SUCCESS =
  "EMAIL_INBOUND_ARCHIVE_LIST_SUCCESS";
export const EMAIL_INBOUND_ARCHIVE_LIST_ERROR =
  "EMAIL_INBOUND_ARCHIVE_LIST_ERROR";

// Email Inbound Unarchive ActionType

export const EMAIL_INBOUND_UNARCHIVE = "EMAIL_INBOUND_UNARCHIVE";
export const EMAIL_INBOUND_UNARCHIVE_SUCCESS =
  "EMAIL_INBOUND_UNARCHIVE_SUCCESS";
export const EMAIL_INBOUND_UNARCHIVE_ERROR = "EMAIL_INBOUND_UNARCHIVE_ERROR";

// mark email as unread
export const EMAIL_INBOUND_MARK_AS_UNREAD = "EMAIL_INBOUND_MARK_AS_UNREAD";
export const EMAIL_INBOUND_MARK_AS_UNREAD_SUCCESS =
  "EMAIL_INBOUND_MARK_AS_UNREAD_SUCCESS";
export const EMAIL_INBOUND_MARK_AS_UNREAD_ERROR =
  "EMAIL_INBOUND_MARK_AS_UNREAD_ERROR";

// Email Account List
export const EMAIL_ACCOUNT_LIST = "EMAIL_ACCOUNT_LIST";
export const EMAIL_ACCOUNT_LIST_SUCCESS = "EMAIL_ACCOUNT_LIST_SUCCESS";
export const EMAIL_ACCOUNT_LIST_ERROR = "EMAIL_ACCOUNT_LIST_ERROR";

// Email Account Details
export const EMAIL_ACCOUNT_DETAILS = "EMAIL_ACCOUNT_DETAILS";
export const EMAIL_ACCOUNT_DETAILS_SUCCESS = "EMAIL_ACCOUNT_DETAILS_SUCCESS";
export const EMAIL_ACCOUNT_DETAILS_ERROR = "EMAIL_ACCOUNT_DETAILS_ERROR";

// Create Email Account
export const EMAIL_ACCOUNT_CREATE = "EMAIL_ACCOUNT_CREATE";
export const EMAIL_ACCOUNT_CREATE_SUCCESS = "EMAIL_ACCOUNT_CREATE_SUCCESS";
export const EMAIL_ACCOUNT_CREATE_ERROR = "EMAIL_ACCOUNT_CREATE_ERROR";

// Update Email Account
export const EMAIL_ACCOUNT_UPDATE = "EMAIL_ACCOUNT_UPDATE";
export const EMAIL_ACCOUNT_UPDATE_SUCCESS = "EMAIL_ACCOUNT_UPDATE_SUCCESS";
export const EMAIL_ACCOUNT_UPDATE_ERROR = "EMAIL_ACCOUNT_UPDATE_ERROR";

// Delete Email Account
export const EMAIL_ACCOUNT_DELETE = "EMAIL_ACCOUNT_DELETE";
export const EMAIL_ACCOUNT_DELETE_SUCCESS = "EMAIL_ACCOUNT_DELETE_SUCCESS";
export const EMAIL_ACCOUNT_DELETE_ERROR = "EMAIL_ACCOUNT_DELETE_ERROR";

//}/jobtoemailinbound/search
export const JOB_EMAIL_INBOUND_SEARCH = "JOB_EMAIL_INBOUND_SEARCH";
export const JOB_EMAIL_INBOUND_SEARCH_SUCCESS =
  "JOB_EMAIL_INBOUND_SEARCH_SUCCESS";
export const JOB_EMAIL_INBOUND_SEARCH_ERROR = "JOB_EMAIL_INBOUND_SEARCH_ERROR";

///jobtoemailinbound/create
export const LINK_JOB_TO_EMAIL = "LINK_JOB_TO_EMAIL";
export const LINK_JOB_TO_EMAIL_SUCCESS = "LINK_JOB_TO_EMAIL_SUCCESS";
export const LINK_JOB_TO_EMAIL_ERROR = "LINK_JOB_TO_EMAIL_ERROR";

///emailoutbound/search/addressbook
export const EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK =
  "EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK";
export const EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_SUCCESS =
  "EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_SUCCESS";
export const EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_ERROR =
  "EMAIL_OUTBOUND_SEARCH_ADDRESS_BOOK_ERROR";

///emailoutbound/search/availableattachments
export const EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS =
  "EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS";
export const EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_SUCCESS =
  "EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_SUCCESS";
export const EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_ERROR =
  "EMAIL_OUTBOUND_SEARCH_AVAILABLE_ATTACHMENTS_ERROR";

///emailtemplate/list
export const EMAIL_TEMPLATE_LIST = "EMAIL_TEMPLATE_LIST";
export const EMAIL_TEMPLATE_LIST_SUCCESS = "EMAIL_TEMPLATE_LIST_SUCCESS";
export const EMAIL_TEMPLATE_LIST_ERROR = "EMAIL_TEMPLATE_LIST_ERROR";

///emailtemplate/search
export const EMAIL_TEMPLATE_SEARCH = "EMAIL_TEMPLATE_SEARCH";
export const EMAIL_TEMPLATE_SEARCH_SUCCESS = "EMAIL_TEMPLATE_SEARCH_SUCCESS";
export const EMAIL_TEMPLATE_SEARCH_ERROR = "EMAIL_TEMPLATE_SEARCH_ERROR";

////emailtemplate/data
export const EMAIL_TEMPLATE_DATA = "EMAIL_TEMPLATE_DATA";
export const EMAIL_TEMPLATE_DATA_SUCCESS = "EMAIL_TEMPLATE_DATA_SUCCESS";
export const EMAIL_TEMPLATE_DATA_ERROR = "EMAIL_TEMPLATE_DATA_ERROR";

///emailtemplate/create
export const EMAIL_TEMPLATE_CREATE = "EMAIL_TEMPLATE_CREATE";
export const EMAIL_TEMPLATE_CREATE_SUCCESS = "EMAIL_TEMPLATE_CREATE_SUCCESS";
export const EMAIL_TEMPLATE_CREATE_ERROR = "EMAIL_TEMPLATE_CREATE_ERROR";

///emailtemplate/update
export const EMAIL_TEMPLATE_UPDATE = "EMAIL_TEMPLATE_UPDATE";
export const EMAIL_TEMPLATE_UPDATE_SUCCESS = "EMAIL_TEMPLATE_UPDATE_SUCCESS";
export const EMAIL_TEMPLATE_UPDATE_ERROR = "EMAIL_TEMPLATE_UPDATE_ERROR";

///emailtemplate/delete
export const EMAIL_TEMPLATE_DELETE = "EMAIL_TEMPLATE_DELETE";
export const EMAIL_TEMPLATE_DELETE_SUCCESS = "EMAIL_TEMPLATE_DELETE_SUCCESS";
export const EMAIL_TEMPLATE_DELETE_ERROR = "EMAIL_TEMPLATE_DELETE_ERROR";

///emailoutbound/sendmail/scheduled
export const EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED =
  "EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED";
export const EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_SUCCESS =
  "EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_SUCCESS";
export const EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_ERROR =
  "EMAIL_OUTBOUND_SEND_MAIL_SCHEDULED_ERROR";
///emaildomain/list
export const EMAIL_DOMAIN_LIST = "EMAIL_DOMAIN_LIST";
export const EMAIL_DOMAIN_LIST_SUCCESS = "EMAIL_DOMAIN_LIST_SUCCESS";
export const EMAIL_DOMAIN_LIST_ERROR = "EMAIL_DOMAIN_LIST_ERROR";
///emaildomain/data
export const EMAIL_DOMAIN_DATA = "EMAIL_DOMAIN_DATA";
export const EMAIL_DOMAIN_DATA_SUCCESS = "EMAIL_DOMAIN_DATA_SUCCESS";
export const EMAIL_DOMAIN_DATA_ERROR = "EMAIL_DOMAIN_DATA_ERROR";
///emaildomain/create
export const EMAIL_DOMAIN_CREATE = "EMAIL_DOMAIN_CREATE";
export const EMAIL_DOMAIN_CREATE_SUCCESS = "EMAIL_DOMAIN_CREATE_SUCCESS";
export const EMAIL_DOMAIN_CREATE_ERROR = "EMAIL_DOMAIN_CREATE_ERROR";
///emaildomain/checkdns
export const EMAIL_DOMAIN_CHECK_DNS = "EMAIL_DOMAIN_CHECK_DNS";
export const EMAIL_DOMAIN_CHECK_DNS_SUCCESS = "EMAIL_DOMAIN_CHECK_DNS_SUCCESS";
export const EMAIL_DOMAIN_CHECK_DNS_ERROR = "EMAIL_DOMAIN_CHECK_DNS_ERROR";
///emaildomain/delete
export const EMAIL_DOMAIN_DELETE = "EMAIL_DOMAIN_DELETE";
export const EMAIL_DOMAIN_DELETE_SUCCESS = "EMAIL_DOMAIN_DELETE_SUCCESS";
export const EMAIL_DOMAIN_DELETE_ERROR = "EMAIL_DOMAIN_DELETE_ERROR";
///emailinbound/reply/autogenerate
export const EMAIL_INBOUND_REPLY_AUTOGENERATE =
  "EMAIL_INBOUND_REPLY_AUTOGENERATE";
export const EMAIL_INBOUND_REPLY_AUTOGENERATE_SUCCESS =
  "EMAIL_INBOUND_REPLY_AUTOGENERATE_SUCCESS";
export const EMAIL_INBOUND_REPLY_AUTOGENERATE_ERROR =
  "EMAIL_INBOUND_REPLY_AUTOGENERATE_ERROR";

///emailinboundrule/list
export const EMAIL_INBOUND_RULE_LIST = "EMAIL_INBOUND_RULE_LIST";
export const EMAIL_INBOUND_RULE_LIST_SUCCESS = "EMAIL_INBOUND_RULE_LIST_SUCCESS";
export const EMAIL_INBOUND_RULE_LIST_ERROR = "EMAIL_INBOUND_RULE_LIST_ERROR";
///emailinboundrule/search
export const EMAIL_INBOUND_RULE_SEARCH = "EMAIL_INBOUND_RULE_SEARCH";
export const EMAIL_INBOUND_RULE_SEARCH_SUCCESS =
  "EMAIL_INBOUND_RULE_SEARCH_SUCCESS";
export const EMAIL_INBOUND_RULE_SEARCH_ERROR = "EMAIL_INBOUND_RULE_SEARCH_ERROR";
///emailinboundrule/data
export const EMAIL_INBOUND_RULE_DATA = "EMAIL_INBOUND_RULE_DATA";
export const EMAIL_INBOUND_RULE_DATA_SUCCESS = "EMAIL_INBOUND_RULE_DATA_SUCCESS";
export const EMAIL_INBOUND_RULE_DATA_ERROR = "EMAIL_INBOUND_RULE_DATA_ERROR";
///emailinboundrule/create
export const EMAIL_INBOUND_RULE_CREATE = "EMAIL_INBOUND_RULE_CREATE";
export const EMAIL_INBOUND_RULE_CREATE_SUCCESS =
  "EMAIL_INBOUND_RULE_CREATE_SUCCESS";
export const EMAIL_INBOUND_RULE_CREATE_ERROR = "EMAIL_INBOUND_RULE_CREATE_ERROR";
///emailinboundrule/update
export const EMAIL_INBOUND_RULE_UPDATE = "EMAIL_INBOUND_RULE_UPDATE";
export const EMAIL_INBOUND_RULE_UPDATE_SUCCESS =
  "EMAIL_INBOUND_RULE_UPDATE_SUCCESS";
export const EMAIL_INBOUND_RULE_UPDATE_ERROR = "EMAIL_INBOUND_RULE_UPDATE_ERROR";
///emailinboundrule/delete
export const EMAIL_INBOUND_RULE_DELETE = "EMAIL_INBOUND_RULE_DELETE";
export const EMAIL_INBOUND_RULE_DELETE_SUCCESS =
  "EMAIL_INBOUND_RULE_DELETE_SUCCESS";
export const EMAIL_INBOUND_RULE_DELETE_ERROR = "EMAIL_INBOUND_RULE_DELETE_ERROR";
///emailinboundrule/run
export const EMAIL_INBOUND_RULE_RUN = "EMAIL_INBOUND_RULE_RUN";
export const EMAIL_INBOUND_RULE_RUN_SUCCESS = "EMAIL_INBOUND_RULE_RUN_SUCCESS";
export const EMAIL_INBOUND_RULE_RUN_ERROR = "EMAIL_INBOUND_RULE_RUN_ERROR";
///emailinboundruleitemfield/list
export const EMAIL_INBOUND_RULE_ITEM_FIELD_LIST =
  "EMAIL_INBOUND_RULE_ITEM_FIELD_LIST";
export const EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_SUCCESS =
  "EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_SUCCESS";
export const EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_ERROR =
  "EMAIL_INBOUND_RULE_ITEM_FIELD_LIST_ERROR";
///systemfunctionoperand/list
export const SYSTEM_FUNCTION_OPERAND_LIST = "SYSTEM_FUNCTION_OPERAND_LIST";
export const SYSTEM_FUNCTION_OPERAND_LIST_SUCCESS =
  "SYSTEM_FUNCTION_OPERAND_LIST_SUCCESS";
export const SYSTEM_FUNCTION_OPERAND_LIST_ERROR =
  "SYSTEM_FUNCTION_OPERAND_LIST_ERROR";
